export const menuCategories = [
  {
    title: "Street Food Delights",
    items: [
      {
        name: "Samosa",
        description: "Crispy pastry filled with spiced potatoes and peas.",
        price: "90",
      },
      {
        name: "Gol Gappe (Pani Puri)",
        description:
          "Hollow crisps filled with tangy tamarind water, chickpeas, and potatoes.",
        price: "120",
      },
      {
        name: "Chaat Papdi",
        description:
          "Crispy wafers topped with potatoes, chickpeas, yogurt, and chutneys.",
        price: "150",
      },
      {
        name: "Chole Bhature",
        description: "Fluffy fried bread served with spicy chickpea curry.",
        price: "200",
      },
    ],
  },
  {
    title: "Kebabs & Grills",
    items: [
      {
        name: "Chicken Tikka Kebab",
        description:
          "Tender chicken marinated in yogurt and spices, grilled to perfection.",
        price: "350",
      },
      {
        name: "Mutton Seekh Kebab",
        description:
          "Minced mutton mixed with aromatic spices, skewered and grilled.",
        price: "400",
      },
    ],
  },
  {
    title: "Main Courses",
    items: [
      {
        name: "Butter Chicken",
        description: "Classic creamy tomato curry with tender grilled chicken.",
        price: "450",
      },
      {
        name: "Paneer Tikka Masala",
        description: "Grilled cottage cheese in a rich, spiced gravy.",
        price: "400",
      },
    ],
  },
  {
    title: "Biryani Specials",
    items: [
      {
        name: "Chicken Dum Biryani",
        description:
          "Aromatic basmati rice and chicken cooked in a sealed pot with spices.",
        price: "500",
      },
      {
        name: "Vegetable Biryani",
        description:
          "Fragrant basmati rice cooked with mixed vegetables and exotic spices.",
        price: "400",
      },
    ],
  },
];
